const EmptyState = () => (
  <div className="text-center text-sm text-gray-400">No metadata defined</div>
);

export default EmptyState;
